import { InterpolationWithTheme } from "@emotion/core";



export const newFeatureBanner: { [key: string]: InterpolationWithTheme<any> } = {
    bannerContainer: {
        background: "rgb(225, 234, 250)",
        display: "flex",
        width: "100%",
        margin: "10px"
    },
    bannerImage: {
        height: "250px"
    },
    bannerRightContainer: {
        marginLeft: "100px",
        color: "rgb(51, 94, 144)"
    },
    stepsList: {
        paddingLeft: "15px"
    },
    stepsListContainer: {
        display: "flex"
    },
    stepsListTextWrapper: {
        display: "flex",
        padding: "10px 0px",
        marginRight: "20px"
    },
    stepsListText: {
        display: "inline-block",
        maxWidth: "200px",
        paddingRight: "5px",
        fontSize: "14px"
    },
    stepsListTextBold: {
        display: "inline-block",
        maxWidth: "200px",
        paddingRight: "5px",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "16px",
    },
    bannerHeader: {
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "30px",
        fontWeight: "bold",
        textTransform: "uppercase"
    },
    newFeatureCtaContainer: {
        marginTop: "30px"
    },
    newFeatureCta: {
        background: "linear-gradient(-225deg, rgb(247, 69, 48) 0%, rgb(255, 46, 115) 100%)",
        borderRadius: "31px",
        boxShadow: "0px 3px 16px 0px rgba(247, 123, 155, 0.71)",
        color: "white",
        border: "none",
        padding: " 10px 30px",
        marginRight: "35px"
    }
}